/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountRef,
  DiscountRefOptional,
  DiscountRefMetaI,
  DiscountRefTrackedI,
} from "./discount-ref";
import { DiscountRefTracked, DiscountRefMeta } from "./discount-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemDiscountInternal,
  ItemDiscountInternalOptional,
  ItemDiscountInternalMetaI,
  ItemDiscountInternalTrackedI,
} from "./item-discount-internal";
import {
  ItemDiscountInternalTracked,
  ItemDiscountInternalMeta,
} from "./item-discount-internal";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemRef,
  ItemRefOptional,
  ItemRefMetaI,
  ItemRefTrackedI,
} from "./item-ref";
import { ItemRefTracked, ItemRefMeta } from "./item-ref";

/**
 *
 * @export
 * @interface CatalogItemDiscountDTO
 */
export interface CatalogItemDiscountDTOOptional extends ItemDiscountInternalOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDiscountDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDiscountDTO
   */
  tempID?: string;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogItemDiscountDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDiscountDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDiscountDTO
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  requiresParentEligibility?: boolean;
  /**
   *
   * @type {DiscountRef}
   * @memberof CatalogItemDiscountDTO
   */
  discountId?: DiscountRefOptional;
  /**
   *
   * @type {ItemRef}
   * @memberof CatalogItemDiscountDTO
   */
  itemId?: ItemRefOptional;
}

export interface CatalogItemDiscountDTO
  extends CatalogItemDiscountDTOOptional, ItemDiscountInternal {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDiscountDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDiscountDTO
   */
  tempID?: string;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogItemDiscountDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDiscountDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDiscountDTO
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  requiresParentEligibility?: boolean;
  /**
   *
   * @type {DiscountRef}
   * @memberof CatalogItemDiscountDTO
   */
  discountId: DiscountRef;
  /**
   *
   * @type {ItemRef}
   * @memberof CatalogItemDiscountDTO
   */
  itemId: ItemRef;
}

export interface CatalogItemDiscountDTOTrackedI extends ItemDiscountInternalOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDiscountDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDiscountDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogItemDiscountDTO
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemDiscountDTO
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemDiscountDTO
   */
  percent?: string;
  percentIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemDiscountDTO
   */
  requiresParentEligibility?: boolean;
  requiresParentEligibilityIsSet: boolean;
  /**
   *
   * @type {DiscountRef}
   * @memberof CatalogItemDiscountDTO
   */
  discountId?: DiscountRefTrackedI;
  discountIdIsSet: boolean;
  /**
   *
   * @type {ItemRef}
   * @memberof CatalogItemDiscountDTO
   */
  itemId?: ItemRefTrackedI;
  itemIdIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemDiscountDTO",
  function (model: CatalogItemDiscountDTO) {
    const transformDatesdiscountId = transformDatesMap.get("DiscountRef");
    if (transformDatesdiscountId && model.discountId) {
      transformDatesdiscountId(model.discountId);
    }
    const transformDatesitemId = transformDatesMap.get("ItemRef");
    if (transformDatesitemId && model.itemId) {
      transformDatesitemId(model.itemId);
    }
  },
);

export type CatalogItemDiscountDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  percent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  requiresParentEligibility: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  discountId: PropertyMeta<DiscountRefMetaI>;
  //isDate: false
  //isDatetime: false
  itemId: PropertyMeta<ItemRefMetaI>;
}>;

export var CatalogItemDiscountDTOMeta: CatalogItemDiscountDTOMetaI =
  {} as CatalogItemDiscountDTOMetaI;
CatalogItemDiscountDTOMeta = typeMeta("CatalogItemDiscountDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  discountType: propertyMeta(
    "discountType",
    false,
    false,
    false,
    DiscountTypeMeta,
  ),
  amountCents: propertyMeta(
    "amountCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  percent: propertyMeta("percent", false, false, false, MetaTypesBase.string),
  requiresParentEligibility: propertyMeta(
    "requiresParentEligibility",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  discountId: propertyMeta("discountId", false, true, false, DiscountRefMeta),
  itemId: propertyMeta("itemId", false, true, false, ItemRefMeta),
});

const metaI = CatalogItemDiscountDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemDiscountInternalMeta]);
  metaI.isDeleted.inheritedFrom = ItemDiscountInternalMeta.isDeleted;
  metaI.isNew.inheritedFrom = ItemDiscountInternalMeta.isNew;
  metaI.assignId.inheritedFrom = ItemDiscountInternalMeta.assignId;
  metaI.tempID.inheritedFrom = ItemDiscountInternalMeta.tempID;
  metaI.discountType.inheritedFrom = ItemDiscountInternalMeta.discountType;
  metaI.amountCents.inheritedFrom = ItemDiscountInternalMeta.amountCents;
  metaI.percent.inheritedFrom = ItemDiscountInternalMeta.percent;
  metaI.requiresParentEligibility.inheritedFrom =
    ItemDiscountInternalMeta.requiresParentEligibility;
  metaI.discountId.inheritedFrom = ItemDiscountInternalMeta.discountId;
  metaI.itemId.inheritedFrom = ItemDiscountInternalMeta.itemId;
});

export class CatalogItemDiscountDTOTracked
  extends ItemDiscountInternalTracked
  implements CatalogItemDiscountDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  percent__I?: string = undefined;
  percentIsSet: boolean = false;
  set percent(v: undefined | string) {
    if (v !== undefined) {
      this.percent__I = v;
      this.percentIsSet = true;
    } else {
      this.percent__I = v || undefined;
      this.percentIsSet = false;
    }
    this.changeTracker = true;
  }
  get percent() {
    return this.percent__I;
  }
  requiresParentEligibility__I?: boolean = undefined;
  requiresParentEligibilityIsSet: boolean = false;
  set requiresParentEligibility(v: undefined | boolean) {
    if (v !== undefined) {
      this.requiresParentEligibility__I = v;
      this.requiresParentEligibilityIsSet = true;
    } else {
      this.requiresParentEligibility__I = v || undefined;
      this.requiresParentEligibilityIsSet = false;
    }
    this.changeTracker = true;
  }
  get requiresParentEligibility() {
    return this.requiresParentEligibility__I;
  }
  discountId__I?: DiscountRefTracked = undefined;
  discountIdIsSet: boolean = false;
  set discountId(v: undefined | DiscountRefTracked) {
    if (v !== undefined) {
      this.discountId__I = v;
      this.discountIdIsSet = true;
    } else {
      this.discountId__I = v || undefined;
      this.discountIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountId() {
    return this.discountId__I;
  }
  itemId__I?: ItemRefTracked = undefined;
  itemIdIsSet: boolean = false;
  set itemId(v: undefined | ItemRefTracked) {
    if (v !== undefined) {
      this.itemId__I = v;
      this.itemIdIsSet = true;
    } else {
      this.itemId__I = v || undefined;
      this.itemIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get itemId() {
    return this.itemId__I;
  }
  constructor(
    config?: CatalogItemDiscountDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.discountId?.setIds();

    this.itemId?.setIds();
  }
  assignFrom(
    config: CatalogItemDiscountDTOOptional,
    options?: AssignOptions,
  ): CatalogItemDiscountDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (config.percent && this.percentApplyFilter(optionsRequired.filter)) {
      this.percent = config.percent;
      if (optionsRequired.unassign) this.percentIsSet = false;
      else this.percentIsSet = true;
    }
    if (
      config.requiresParentEligibility &&
      this.requiresParentEligibilityApplyFilter(optionsRequired.filter)
    ) {
      this.requiresParentEligibility = config.requiresParentEligibility;
      if (optionsRequired.unassign) this.requiresParentEligibilityIsSet = false;
      else this.requiresParentEligibilityIsSet = true;
    }
    if (
      config.discountId &&
      this.discountIdApplyFilter(optionsRequired.filter)
    ) {
      this.discountId = new DiscountRefTracked(config.discountId, options);
      if (optionsRequired.unassign) this.discountIdIsSet = false;
      else this.discountIdIsSet = true;
    }
    if (config.itemId && this.itemIdApplyFilter(optionsRequired.filter)) {
      this.itemId = new ItemRefTracked(config.itemId, options);
      if (optionsRequired.unassign) this.itemIdIsSet = false;
      else this.itemIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemDiscountDTOTrackedI {
    const cloned = {} as CatalogItemDiscountDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.percentIsSetDeep() &&
      this.percentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.percentIsSet = true;
      cloned.percent = this.percent;
    } else {
      //cloned.percentIsSet = false
    }
    if (
      this.requiresParentEligibilityIsSetDeep() &&
      this.requiresParentEligibilityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.requiresParentEligibilityIsSet = true;
      cloned.requiresParentEligibility = this.requiresParentEligibility;
    } else {
      //cloned.requiresParentEligibilityIsSet = false
    }
    if (
      this.discountIdIsSetDeep() &&
      this.discountIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountIdIsSet = true;
      cloned.discountId = this.discountId?.removeUnset(filter);
    } else {
      //cloned.discountIdIsSet = false
    }
    if (
      this.itemIdIsSetDeep() &&
      this.itemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemIdIsSet = true;
      cloned.itemId = this.itemId?.removeUnset(filter);
    } else {
      //cloned.itemIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemDiscountDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.percentApplyFilter(filter)) this.percentIsSet = false;

    if (!this.requiresParentEligibilityApplyFilter(filter))
      this.requiresParentEligibilityIsSet = false;

    if (!this.discountIdApplyFilter(filter)) this.discountIdIsSet = false;
    this.discountId?.unassignAll(filter);

    if (!this.itemIdApplyFilter(filter)) this.itemIdIsSet = false;
    this.itemId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.isDeleted,
      CatalogItemDiscountDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.isNew,
      CatalogItemDiscountDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.assignId,
      CatalogItemDiscountDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.tempID,
      CatalogItemDiscountDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.discountType,
      CatalogItemDiscountDTOMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.amountCents,
      CatalogItemDiscountDTOMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  percentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.percent,
      CatalogItemDiscountDTOMeta,
      this.percent,
      this,
    );
  }
  percentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.percentIsSet && this.percentApplyFilter(filter)) return true;

    return false;
  }
  requiresParentEligibilityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.requiresParentEligibility,
      CatalogItemDiscountDTOMeta,
      this.requiresParentEligibility,
      this,
    );
  }
  requiresParentEligibilityIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.requiresParentEligibilityIsSet &&
      this.requiresParentEligibilityApplyFilter(filter)
    )
      return true;

    return false;
  }
  discountIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.discountId,
      CatalogItemDiscountDTOMeta,
      this.discountId,
      this,
    );
  }
  discountIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountIdIsSet && this.discountIdApplyFilter(filter)) return true;
    return this.discountId?.anySet(filter) == true;

    return false;
  }
  itemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemDiscountDTOMeta.itemId,
      CatalogItemDiscountDTOMeta,
      this.itemId,
      this,
    );
  }
  itemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemIdIsSet && this.itemIdApplyFilter(filter)) return true;
    return this.itemId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.percentIsSetDeep(filter)) return true;
    if (this.requiresParentEligibilityIsSetDeep(filter)) return true;
    if (this.discountIdIsSetDeep(filter)) return true;
    if (this.itemIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
